import * as PIXI from "pixi.js-legacy"

import * as constants from "./constants"

export default class TextManager {

	constructor(player, stageContainer) {
		this._player = player
		this._stageContainer = stageContainer

		// Create a PIXI container and add it to the PIXI stage
		this._container = new PIXI.Container()
		this._container.name = "textContainer"
		this._stageContainer.addChild(this._container)

		// Create a PIXI text object
		this._textObject = new PIXI.Text("", {
			fontFamily: constants.textFontFamily,
			fontSize: constants.textFontSize,
			fill: constants.textFillColor,
			align: "center",
			wordWrap: true,
			wordWrapWidth: constants.wordWrapWidth,
		})
		this._textObject.anchor.set(0.5)
		this._container.addChild(this._textObject)

		// Create default message
		this._message = { type: null, text: "" }
	}

	resize() {
		const { viewportSize } = this._player
		const { width, height } = viewportSize
		// Move the _container's pivot so that the text object is always centered
		if (!this._container) {
			return
		}
		this._container.pivot = {
			x: -width / 2,
			y: -height / 2,
		}
	}

	showMessage(message) {
		// Do note that message.text can be === 0 (when resource loading starts, for example)
		if (!message || !message.type
			|| message.text === undefined || message.text === null) {
			return
		}

		// Write full text based on message type
		const { type, text } = message
		let fullText
		switch (type) {
		case "loading":
			fullText = `Loading... ${text}%`
			break
		case "error":
			fullText = `ERROR!\n${text}`
			break
		default:
			break
		}
		if (fullText) {
			this._textObject.text = fullText
		}
	}

	// The destroy function is already run once all resources are loaded
	// So ensure its call by Player does not try and accomplish the same
	destroy() {
		if (this._container) {
			// Remove the _container from the PIXI application's stageContainer
			this._stageContainer.removeChild(this._container)
			this._container = null
		}
		if (this._textObject) {
			// Destroy the PIXI text object
			this._textObject.destroy({ children: true, texture: true, baseTexture: true })
			this._textObject = null
		}
	}

}